import VuePrintToPaper from '../plugins/VuePrintToPaper';

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(VuePrintToPaper, options)

    }
}
